import React from "react";

import { useState } from "react";

import BodyMain from "../BodyMain/BodyMain";
import classes from "./InitialLook.module.css";
export default function InitialLook(props) {
  const [formShoew, setFormShoew] = useState(false);
  const clickHandler = () => {
    setFormShoew(true);
  };
  return (
    <section className={classes.section}>
      <div className={classes.sidebarContainer}>
        <p>TRY OUR ONLINE EDITOR</p>

        <span className={classes.sidebarContainerButtonAfter}>
          <button
            className={classes.sidebarContainerButton}
            onClick={clickHandler}
          >
            New Project
          </button>
        </span>

        <div>Search Project</div>
        <div>Challenges</div>
        <div>
          CodeEditor<span className={classes.span}>pro</span>
        </div>
      </div>
      <BodyMain onshow={formShoew} onprojectCreation={setFormShoew} />
    </section>
  );
}
